(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpAtcLoadingInit) return;
    window.__pdpAtcLoadingInit = true;

    document.addEventListener('submit', function (e) {
      var productForm = e.target && e.target.closest && e.target.closest('product-form-component');
      if (!productForm) return;
      var btn = productForm.querySelector('[ref="addToCartButton"]');
      if (!btn || btn.disabled) return;
      btn.classList.add('is-loading');
    }, true);

    var removeLoading = function () {
      document.querySelectorAll('[ref="addToCartButton"].is-loading').forEach(function (btn) {
        btn.classList.remove('is-loading');
      });
    };
    document.addEventListener('cart:update', removeLoading);
    document.addEventListener('cart:error', removeLoading);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Prevent product link navigation when swiping the card gallery carousel (PLP).
  const SWIPE_THRESHOLD = 8;

  document.addEventListener('pointerdown', (e) => {
    const slide = e.target.closest('.card-gallery slideshow-slide');
    if (!slide) return;

    const startX = e.clientX;
    const startY = e.clientY;

    const link = slide.querySelector('a');
    if (!link) return;

    const onClick = (clickEvent) => {
      const dx = Math.abs(clickEvent.clientX - startX);
      const dy = Math.abs(clickEvent.clientY - startY);
      if (dx > SWIPE_THRESHOLD || dy > SWIPE_THRESHOLD) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      }
    };

    link.addEventListener('click', onClick, { once: true });
    setTimeout(() => link.removeEventListener('click', onClick), 2000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-variant-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    var modal = document.getElementById('cart-variant-modal');
    if (!modal) return;

    var currentCartKey = null;
    var originalVariantId = null;
    var selectedVariantId = null;
    var availableVariants = [];
    var currentQuantity = 1;
    var currentProductData = null;

    var FAST_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.29395 11.9796C4.04705 11.9796 4.66016 12.5927 4.66016 13.3458C4.66012 14.099 4.04703 14.712 3.29395 14.712C2.54089 14.7118 1.92875 14.0989 1.92871 13.3458C1.92871 12.5928 2.54087 11.9798 3.29395 11.9796ZM12.1875 11.9796C12.9406 11.9796 13.5537 12.5927 13.5537 13.3458C13.5537 14.099 12.9405 14.7119 12.1875 14.712C11.4343 14.712 10.8213 14.099 10.8213 13.3458C10.8213 12.5927 11.4342 11.9796 12.1875 11.9796ZM9.48242 4.53425C9.65965 4.53447 9.80371 4.67826 9.80371 4.85554V6.30085H12.0566C12.1516 6.30085 12.2417 6.34333 12.3027 6.41608L14.9248 9.54987C14.9732 9.60757 15 9.68138 15 9.7569V12.8907C14.9998 13.0679 14.856 13.2119 14.6787 13.212H14.3379C14.1787 13.2119 14.0382 13.0973 14.0176 12.9395C13.8914 11.973 13.1201 11.3731 12.1875 11.3731C11.2549 11.3732 10.4836 11.973 10.3574 12.9395C10.3368 13.0972 10.1962 13.212 10.0371 13.212H9.69629C9.65838 13.212 9.62263 13.2035 9.58887 13.1915C9.55531 13.2035 9.52005 13.2129 9.48242 13.213H5.44531C5.28635 13.213 5.14599 13.0978 5.125 12.9405C4.99886 11.9741 4.22741 11.3742 3.29492 11.3741C2.3623 11.3741 1.591 11.9739 1.46484 12.9405C1.4439 13.0978 1.30324 13.2128 1.14453 13.213H0.321289C0.143905 13.2129 0.000245156 13.0679 0 12.8907V4.91999L2.94629 6.23054L2.26758 8.77448C2.09838 9.6224 3.24047 10.1773 3.79492 9.62312L8.88281 4.53425H9.48242ZM10.3389 6.9444C10.1614 6.9446 10.0176 7.0884 10.0176 7.26569V8.87214C10.0176 9.04962 10.1614 9.19421 10.3389 9.1944H13.0938C13.3663 9.1944 13.5152 8.87646 13.3408 8.66706L12.002 7.05964C11.9409 6.98638 11.8502 6.9444 11.7549 6.9444H10.3389ZM6.23633 0.00202214C6.29856 -0.00538066 6.36182 0.00766541 6.41602 0.0391315C6.47016 0.0706279 6.51273 0.119136 6.53711 0.176827C6.56147 0.234658 6.5661 0.299568 6.55078 0.360421L5.87695 2.98151L7.91504 3.87409C7.95826 3.89329 7.99622 3.9228 8.02539 3.96003C8.05465 3.99745 8.07383 4.04215 8.08203 4.08894C8.09018 4.13565 8.08704 4.18352 8.07227 4.22858C8.05748 4.27368 8.03231 4.31489 7.99805 4.34773H7.99902L3.7207 8.46003C3.67553 8.50317 3.61767 8.53068 3.55566 8.53815C3.49348 8.54555 3.43014 8.53246 3.37598 8.50105C3.32182 8.46954 3.27926 8.42106 3.25488 8.36335C3.23059 8.30567 3.22506 8.24144 3.24023 8.18073L3.91309 5.56159L1.87598 4.66804C1.83221 4.6489 1.79317 4.6187 1.76367 4.58112C1.73434 4.54363 1.71423 4.49912 1.70605 4.45222C1.69796 4.40531 1.7018 4.35678 1.7168 4.31159C1.73186 4.26634 1.75831 4.22521 1.79297 4.19245L6.07031 0.0801471C6.11559 0.0367922 6.17409 0.0094666 6.23633 0.00202214Z" fill="#F26216"/></svg>';

    var CHEVRON_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4.5 9l3-3-3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    var SIZE_CHART_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 6L8 11L3 6" stroke="#343330" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var FAST_DELIVERY_CARD_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.39193 15.9728C5.39606 15.9728 6.21354 16.7903 6.21354 17.7944C6.21349 18.7986 5.39604 19.616 4.39193 19.616C3.38786 19.6159 2.575 18.7986 2.57495 17.7944C2.57495 16.7904 3.38783 15.973 4.39193 15.9728ZM16.25 15.9728C17.2541 15.9728 18.0716 16.7903 18.0716 17.7944C18.0716 18.7986 17.254 19.6159 16.25 19.616C15.2458 19.616 14.4284 18.7986 14.4284 17.7944C14.4284 16.7903 15.2457 15.9728 16.25 15.9728ZM12.6432 6.04567C12.8795 6.04597 13.0716 6.23768 13.0716 6.47406V8.40113H16.0755C16.2021 8.40113 16.3222 8.45778 16.4036 8.55478L19.8997 12.7332C19.9643 12.8101 20 12.9085 20 13.0092V17.1876C19.9997 17.4239 19.788 17.6159 19.5716 17.616H19.1172C18.9049 17.6159 18.7176 17.463 18.6901 17.2527C18.5219 15.964 17.4935 15.1641 16.25 15.1641C15.0066 15.1641 13.9781 15.964 13.8099 17.2527C13.7824 17.463 13.5949 17.616 13.3828 17.616H12.928C12.878 17.616 12.8302 17.6047 12.7852 17.5887C12.7404 17.6047 12.6934 17.6172 12.6432 17.6173H7.26042C7.04847 17.6173 6.86133 17.4641 6.83333 17.2541C6.66515 15.9654 5.63655 15.1656 4.39323 15.1654C3.14973 15.1654 2.12134 15.9652 1.95312 17.2541C1.9252 17.4638 1.73765 17.617 1.52604 17.6173H0.428385C0.191873 17.6172 0.000326875 17.4239 0 17.1876V6.55999L3.92839 8.30738L3.02344 11.6993C2.79784 12.8299 4.32063 13.5697 5.05989 12.8308L11.8438 6.04567H12.6432ZM13.7852 9.2592C13.5486 9.26147 13.3568 9.4512 13.3568 9.68759V11.8295C13.3568 12.0662 13.5486 12.2589 13.7852 12.2592H17.4584C17.8217 12.2592 18.0203 11.8353 17.7878 11.5561L16.0027 9.41285C15.9212 9.3185 15.8003 9.2592 15.6732 9.2592H13.7852ZM8.31511 0.00269619C8.39808 -0.00717421 8.4824 0.0102205 8.55469 0.0521753C8.62689 0.094171 8.68364 0.158848 8.71615 0.235769C8.74863 0.312877 8.75481 0.399424 8.73438 0.480561L7.83594 3.97535L10.5534 5.16546C10.6110 5.19106 10.6616 5.22707 10.7005 5.27337C10.7395 5.31994 10.7651 5.37621 10.7761 5.43859C10.7869 5.50087 10.7827 5.56469 10.7630 5.63811C10.7433 5.69824 10.7100 5.75319 10.6641 5.79697H10.6654L4.94759 11.28C4.90071 11.3376 4.82356 11.3742 4.74088 11.3842C4.65798 11.394 4.57352 11.3766 4.50131 11.3347C4.42909 11.2927 4.37234 11.2281 4.33984 11.1511C4.30746 11.0742 4.30008 10.9886 4.32031 10.9076L5.21745 7.41546L2.50131 6.22405C2.44295 6.19853 2.39089 6.16494 2.35156 6.12149C2.31245 6.07817 2.28564 6.02549 2.27474 5.96963C2.26395 5.91375 2.26907 5.85571 2.28907 5.80212C2.30914 5.74179 2.34441 5.68694 2.39063 5.64327L8.09375 0.106863C8.15413 0.0490563 8.23213 0.0126221 8.31511 0.00269619Z" fill="#F26216"/></svg>';

    var RETURNS_CARD_SVG = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 9.99987C17.5002 11.9717 16.7239 13.8642 15.3391 15.2679C13.9543 16.6715 12.0724 17.4734 10.1008 17.4999H10C8.08457 17.5046 6.24086 16.7716 4.85157 15.453C4.79191 15.3966 4.74395 15.3289 4.71043 15.254C4.6769 15.179 4.65847 15.0982 4.65619 15.0161C4.6539 14.934 4.66781 14.8523 4.69711 14.7756C4.72641 14.6989 4.77054 14.6287 4.82696 14.569C4.88339 14.5093 4.95102 14.4614 5.02598 14.4279C5.10094 14.3943 5.18177 14.3759 5.26386 14.3736C5.34594 14.3713 5.42768 14.3852 5.50439 14.4145C5.5811 14.4438 5.65129 14.488 5.71095 14.5444C6.60454 15.3871 7.72664 15.9479 8.93707 16.1566C10.1475 16.3653 11.3926 16.2127 12.5168 15.7179C13.641 15.2231 14.5945 14.408 15.2582 13.3745C15.9219 12.3409 16.2663 11.1347 16.2484 9.90654C16.2305 8.67838 15.8512 7.48271 15.1577 6.4689C14.4643 5.45509 13.4875 4.66808 12.3493 4.2062C11.2112 3.74431 9.96217 3.62802 8.75833 3.87186C7.55448 4.11569 6.44918 4.70884 5.58048 5.57721C5.5741 5.58411 5.56731 5.59064 5.56017 5.59674L4.73673 6.35065L6.06485 7.67877C6.15357 7.76583 6.21431 7.87736 6.23932 7.99911C6.26433 8.12086 6.25247 8.24731 6.20526 8.36229C6.15804 8.47727 6.07762 8.57555 5.97426 8.64459C5.8709 8.71363 5.7493 8.75028 5.62501 8.74987H1.87501C1.70925 8.74987 1.55028 8.68402 1.43307 8.56681C1.31586 8.4496 1.25001 8.29063 1.25001 8.12487V4.37487C1.24929 4.25092 1.28544 4.12955 1.35388 4.0262C1.42231 3.92285 1.51992 3.84218 1.63432 3.79444C1.74871 3.74671 1.87471 3.73407 1.99631 3.75813C2.1179 3.78218 2.2296 3.84186 2.3172 3.92955L3.85235 5.46862L4.70704 4.68737C5.75703 3.64146 7.09334 2.93008 8.5473 2.64302C10.0013 2.35596 11.5077 2.50609 12.8764 3.07447C14.2451 3.64284 15.4147 4.60398 16.2376 5.83654C17.0605 7.06911 17.4998 8.51785 17.5 9.99987Z" fill="#111827"/></svg>';

    // Same drawing as assets/icon-info.svg, copied: Liquid does not run inside the javascript tag.
    var HELP_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.5V8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.5H8.005" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function escapeHtml(s) {
      if (s == null) return '';
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function buildPreview(data) {
      var hasDiscount = data.compare_price_numeric && data.price_numeric && data.compare_price_numeric > data.price_numeric;
      var discountPct = hasDiscount ? Math.round((1 - data.price_numeric / data.compare_price_numeric) * 100) : 0;
      var imgHtml = data.image ? '<img src="' + escapeHtml(data.image) + '" alt="' + escapeHtml(data.title) + '" loading="lazy">' : '';
      var compareHtml = hasDiscount ? '<span class="qs-price-compare">' + escapeHtml(data.compare_price) + '</span><span class="qs-price-badge">' + discountPct + '% off</span>' : '';
      var viewProductHtml = data.url ? '<a href="' + escapeHtml(data.url) + '" class="qs-view-product">View Product ' + CHEVRON_SVG + '</a>' : '';

      return (
        '<div class="qs-preview">' +
          '<div class="qs-preview-image">' + imgHtml + '</div>' +
          '<div class="qs-preview-content">' +
            '<h3 class="qs-preview-title">' + escapeHtml(data.title) + '</h3>' +
            '<div class="qs-preview-price">' +
              '<span class="qs-price-current" data-price-current>' + escapeHtml(data.price) + '</span>' +
              '<span class="qs-price-compare" data-price-compare' + (hasDiscount ? '' : ' style="display:none"') + '>' + (hasDiscount ? escapeHtml(data.compare_price) : '') + '</span>' +
              '<span class="qs-price-badge" data-price-badge' + (hasDiscount ? '' : ' style="display:none"') + '>' + (hasDiscount ? discountPct + '% off' : '') + '</span>' +
            '</div>' +
            viewProductHtml +
          '</div>' +
        '</div>'
      );
    }

    function buildSizeHeader(data) {
      var chartLink = '';
      if (data.has_size_chart && data.id) {
        chartLink =
          '<button type="button" class="qs-size-chart-link" data-cart-variant-size-chart data-product-id="' + escapeHtml(data.id) + '">' +
            'Size chart ' + SIZE_CHART_ICON_SVG +
          '</button>';
      }
      return (
        '<div class="qs-size-header">' +
          '<label class="qs-option-label">Select size</label>' +
          chartLink +
        '</div>'
      );
    }

    function buildSizePills() {
      var pillsHtml = '';
      availableVariants.forEach(function(variant) {
        var sizeLabel = variant.size && String(variant.size).trim() ? variant.size : variant.title;
        var isSelected = variant.id === selectedVariantId;
        var isSoldOut = !variant.available;
        var classes = ['qs-size-option'];
        if (isSelected) classes.push('selected');
        if (isSoldOut) classes.push('sold-out');
        if (variant.fast_delivery) classes.push('qs-size-option--fast');

        var fastIcon = variant.fast_delivery ? '<span class="qs-size-fast-icon" aria-hidden="true">' + FAST_ICON_SVG + '</span>' : '';
        var disabledAttr = isSoldOut ? ' disabled' : '';

        var stockLabel = '';
        if (variant.low_stock && variant.inventory_quantity > 0) {
          stockLabel = '<span class="qs-stock qs-stock--low">Only ' + variant.inventory_quantity + ' left</span>';
        } else if (variant.sold_out || isSoldOut) {
          stockLabel = '<span class="qs-stock qs-stock--out">Sold out</span>';
        }

        pillsHtml +=
          '<div class="qs-pill-item">' +
            '<button type="button" class="' + classes.join(' ') + '" data-variant-id="' + variant.id + '"' + disabledAttr + '>' +
              fastIcon +
              '<span class="qs-size-value">' + escapeHtml(sizeLabel) + '</span>' +
            '</button>' +
            stockLabel +
          '</div>';
      });
      return '<div class="qs-sizes">' + pillsHtml + '</div>';
    }

    function buildDeliveryInfo(data) {
      var showFast = !!(data && data.has_fast_delivery);
      var showReturns = !(data && data.non_returnable);
      if (!showFast && !showReturns) return '';
      var fastHtml = showFast
        ? (
            '<div class="qs-info-item">' +
              '<div class="qs-info-icon">' + FAST_DELIVERY_CARD_SVG + '</div>' +
              '<div class="qs-info-text"><span class="qs-info-label">Fast Delivery within 2-4 days</span></div>' +
              '<button type="button" class="qs-info-help" aria-label="Shipping policy details" on:click="#cart-qs-shipping-sheet/showDialog" aria-haspopup="dialog">' + HELP_SVG + '</button>' +
            '</div>'
          )
        : '';
      var returnsHtml = showReturns
        ? (
            '<div class="qs-info-item">' +
              '<div class="qs-info-icon">' + RETURNS_CARD_SVG + '</div>' +
              '<div class="qs-info-text"><span class="qs-info-label">Easy returns up to 7 days</span></div>' +
              '<button type="button" class="qs-info-help" aria-label="Return policy details" on:click="#cart-qs-returns-sheet/showDialog" aria-haspopup="dialog">' + HELP_SVG + '</button>' +
            '</div>'
          )
        : '';
      return (
        '<div class="qs-delivery-info">' +
          fastHtml +
          returnsHtml +
        '</div>'
      );
    }

    function buildActions() {
      return (
        '<div class="qs-actions">' +
          '<button type="button" class="qs-buy-now" data-cart-variant-close>Go Back</button>' +
          '<button type="button" class="qs-add-to-bag" data-cart-variant-submit>' +
            '<span class="button-text">Add to Bag</span>' +
            '<span class="btn-spinner" aria-hidden="true"></span>' +
          '</button>' +
        '</div>'
      );
    }

    function updatePriceDisplay(variant) {
      var body = modal.querySelector('[data-cart-variant-body]');
      if (!body) return;
      var currentEl = body.querySelector('[data-price-current]');
      var compareEl = body.querySelector('[data-price-compare]');
      var badgeEl = body.querySelector('[data-price-badge]');
      if (!currentEl) return;

      currentEl.textContent = variant.price || '';
      var hasDiscount = variant.compare_price_numeric && variant.compare_price_numeric > variant.price_numeric;
      if (hasDiscount) {
        var pct = Math.round((1 - variant.price_numeric / variant.compare_price_numeric) * 100);
        if (compareEl) {
          compareEl.textContent = variant.compare_price || '';
          compareEl.style.display = '';
        }
        if (badgeEl) {
          badgeEl.textContent = pct + '% off';
          badgeEl.style.display = '';
        }
      } else {
        if (compareEl) {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
        if (badgeEl) {
          badgeEl.textContent = '';
          badgeEl.style.display = 'none';
        }
      }
    }

    window.openVariantModal = function(key, productData) {
      currentCartKey = key;

      var data = typeof productData === 'string' ? JSON.parse(productData) : productData;
      currentProductData = data;
      currentQuantity = data.current_quantity || 1;
      originalVariantId = data.current_variant_id;
      selectedVariantId = data.current_variant_id;
      availableVariants = data.variants || [];

      /* Fresh-add path (no cart key): pre-select first available variant */
      if (!selectedVariantId) {
        var firstAvail = availableVariants.find(function(v) { return v.available; });
        if (firstAvail) selectedVariantId = firstAvail.id;
      }

      var body = modal.querySelector('[data-cart-variant-body]');
      if (!body) return;

      body.innerHTML =
        buildPreview(data) +
        '<div class="qs-option-group">' +
          buildSizeHeader(data) +
          buildSizePills() +
        '</div>' +
        buildDeliveryInfo(data) +
        buildActions();

      /* Sync price display with the pre-selected variant */
      if (selectedVariantId) {
        var selVar = availableVariants.find(function(v) { return v.id === selectedVariantId; });
        if (selVar) updatePriceDisplay(selVar);
      }

      modal.showModal();

      /* Redirect auto-focus from the close button to the dialog itself so
         mouse-opened modals don't show a focus ring on the close icon. */
      modal.focus({ preventScroll: true });
    };

    window.selectVariant = function(variantId, element) {
      selectedVariantId = variantId;
      var body = modal.querySelector('[data-cart-variant-body]');
      if (!body) return;
      body.querySelectorAll('.qs-size-option').forEach(function(opt) {
        opt.classList.remove('selected');
      });
      if (element) element.classList.add('selected');
      var variant = availableVariants.find(function(v) { return v.id === variantId; });
      if (variant) updatePriceDisplay(variant);
    };

    window.closeVariantModal = function() {
      modal.close();
      currentCartKey = null;
      originalVariantId = null;
      selectedVariantId = null;
      availableVariants = [];
      currentProductData = null;
    };

    window.updateCartVariant = function() {
      if (!selectedVariantId) return;

      /* Same variant — nothing to swap, just close */
      if (selectedVariantId === originalVariantId) {
        window.closeVariantModal();
        return;
      }

      var isFreshAdd = !currentCartKey;
      var qty = currentQuantity || 1;
      var keyToRemove = currentCartKey;
      var submitBtn = modal.querySelector('[data-cart-variant-submit]');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
      }

      function resetBtn() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
      }

      /* Collect section IDs for sync morph */
      function getCartSectionIds() {
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function(el) {
          if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
        });
        return ids;
      }
      var sectionIds = getCartSectionIds();
      var sectionsParam = sectionIds.length ? sectionIds.join(',') : '';

      function refreshBag(response) {
        resetBtn();
        window.closeVariantModal();

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: response,
            sourceId: 'cart-variant-modal',
            data: { source: 'cart-variant-modal', sections: response.sections || {} }
          }
        }));

        window.__variantModalSourceCard = null;
      }

      var addPayload = { id: selectedVariantId, quantity: qty };
      if (sectionsParam) addPayload.sections = sectionsParam;

      /* Step 1: add new variant */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addPayload)
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(err) {
          var addError = new Error(err.description || 'Could not add variant');
          addError.fromAdd = !!err.description;
          throw addError;
        });
        return r.json();
      })
      .then(function(addResponse) {
        if (isFreshAdd) {
          refreshBag(addResponse);
          return;
        }

        /* Swap mode — Step 2: remove old variant */
        var changePayload = { id: keyToRemove, quantity: 0 };
        if (sectionsParam) changePayload.sections = sectionsParam;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(changePayload)
        })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(err) { throw new Error(err.errors || 'Could not remove old variant'); });
          return r.json();
        })
        .then(function(changeResponse) {
          refreshBag(changeResponse);
        });
      })
      .catch(function(error) {
        console.error('Error updating variant:', error);
        resetBtn();

        /* Say so, and redraw the bag from the cart as it now stands: when the new
           size went in but the old one could not be taken out, both are in it. */
        var message = 'Could not change the size. Please check your bag.';
        /* Said in the bag's own toast. The bag's section is asked for with the
           cart so the bag redraws at once and the toast is not wiped by a late
           redraw. */
        var bag = modal.closest('cart-drawer-v2');
        var sayInBag = function() {
          if (bag && typeof bag.showToast === 'function') bag.showToast(message, 'error');
        };
        /* The add itself was refused (e.g. that size sold out): nothing changed,
           so no redraw, and Shopify's own reason says more than the generic line.
           The modal is closed so the toast in the bag under it can be seen. */
        if (error && error.fromAdd) {
          message = error.message;
          window.closeVariantModal();
          window.__variantModalSourceCard = null;
          sayInBag();
          return;
        }
        var failSections = sectionsParam || (bag && bag.dataset.sectionId) || '';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(failSections ? { sections: failSections } : {})
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) { refreshBag(cart); sayInBag(); })
        .catch(sayInBag);
      });
    };

    /* Event delegation inside the modal body — handles close, submit, size-chart, and pill selection. */
    modal.addEventListener('click', function(e) {
      /* Backdrop click */
      if (e.target === modal) {
        window.closeVariantModal();
        return;
      }

      var closeBtn = e.target.closest('[data-cart-variant-close]');
      if (closeBtn) {
        e.preventDefault();
        window.closeVariantModal();
        return;
      }

      var submitBtn = e.target.closest('[data-cart-variant-submit]');
      if (submitBtn) {
        e.preventDefault();
        window.updateCartVariant();
        return;
      }

      var chartBtn = e.target.closest('[data-cart-variant-size-chart]');
      if (chartBtn) {
        e.preventDefault();
        var productId = chartBtn.getAttribute('data-product-id');
        if (productId) {
          document.dispatchEvent(new CustomEvent('ssc:open', { detail: { productId: productId } }));
        }
        return;
      }

      var pillBtn = e.target.closest('.qs-size-option');
      if (pillBtn && !pillBtn.disabled) {
        e.preventDefault();
        var variantId = parseInt(pillBtn.getAttribute('data-variant-id'), 10);
        if (variantId) window.selectVariant(variantId, pillBtn);
      }
    });

    /* Native Escape key cancel */
    modal.addEventListener('cancel', function(e) {
      e.preventDefault();
      window.closeVariantModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    /* Initialize (or re-initialize) all price sliders.
     Called on DOMContentLoaded AND after filter morphs replace the DOM. */
  window.__initPriceSliders = function() {
    document.querySelectorAll('price-facet-component').forEach(function (facet) {
      /* Skip if already initialized (prevents double-binding) */
      if (facet.dataset.sliderBound) return;
      facet.dataset.sliderBound = '1';

      var sliderMin = facet.querySelector('[ref="sliderMin"]');
      var sliderMax = facet.querySelector('[ref="sliderMax"]');
      var sliderFill = facet.querySelector('[ref="sliderFill"]');
      var minInput = facet.querySelector('[ref="minInput"]');
      var maxInput = facet.querySelector('[ref="maxInput"]');

      if (!sliderMin || !sliderMax || !sliderFill || !minInput || !maxInput) return;

      var rangeMax = parseFloat(sliderMax.max) || 1;

      /* Strip commas/spaces and parse to number */
      function parseVal(str) {
        if (!str || str.trim() === '') return null;
        return parseFloat(str.replace(/[^0-9.\-]/g, '')) || 0;
      }

      function updateFill() {
        var lo = parseFloat(sliderMin.value) || 0;
        var hi = parseFloat(sliderMax.value) || rangeMax;
        var pctLo = (lo / rangeMax) * 100;
        var pctHi = (hi / rangeMax) * 100;
        sliderFill.style.left = pctLo + '%';
        sliderFill.style.width = (pctHi - pctLo) + '%';

        /* When thumbs overlap, swap z-index so the movable one is on top.
           At max → max thumb on top (drag down). At min → min on top (drag up). */
        if (lo === hi) {
          var atMax = hi >= rangeMax;
          sliderMin.style.zIndex = atMax ? '2' : '4';
          sliderMax.style.zIndex = atMax ? '4' : '2';
        } else {
          sliderMin.style.zIndex = '';
          sliderMax.style.zIndex = '';
        }
      }

      function onSliderInput() {
        var lo = parseFloat(sliderMin.value);
        var hi = parseFloat(sliderMax.value);
        if (lo > hi) {
          var tmp = lo;
          sliderMin.value = hi;
          sliderMax.value = tmp;
        }
        /* Write numeric value into the text inputs */
        minInput.value = sliderMin.value;
        maxInput.value = sliderMax.value;
        updateFill();
      }

      function onSliderChange() {
        onSliderInput();
        /* Trigger the existing price facet change handler */
        minInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function onInputChange() {
        var lo = parseVal(minInput.value);
        var hi = parseVal(maxInput.value);
        if (lo !== null) sliderMin.value = Math.min(lo, rangeMax);
        if (hi !== null) sliderMax.value = Math.min(hi, rangeMax);
        updateFill();
      }

      sliderMin.addEventListener('input', onSliderInput);
      sliderMax.addEventListener('input', onSliderInput);
      sliderMin.addEventListener('change', onSliderChange);
      sliderMax.addEventListener('change', onSliderChange);
      minInput.addEventListener('change', onInputChange);
      maxInput.addEventListener('change', onInputChange);
      /* blocks/filters.liquid restores the inputs when the drawer reopens, then asks for a redraw */
      facet.addEventListener('price-facet:sync', updateFill);

      /* Sync slider from text input initial values on load */
      var initMin = parseVal(minInput.value);
      var initMax = parseVal(maxInput.value) || parseVal(maxInput.placeholder);
      if (initMin !== null) sliderMin.value = Math.min(initMin, rangeMax);
      if (initMax !== null) sliderMax.value = Math.min(initMax, rangeMax);

      updateFill();
    });
  };

  /* Init on first load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__initPriceSliders);
  } else {
    window.__initPriceSliders();
  }

  /* Re-init after filter morph replaces the slider DOM */
  document.addEventListener('filter:update', function() {
    /* Small delay to let the morph complete */
    setTimeout(window.__initPriceSliders, 100);
  });
  } catch(e) { console.error(e); }
})();

})();
